import React from "react";
import LeftNav from "../common/leftnav";
import BillingSubscription from "./billing_subscription/BillingSubscription";
import BillingDetails from "./billing_details/BillingDetails";
import InvoiceHistory from "./billing_details/InvoiceHistory";

const Billing = () => {
  return (
    <div className="d-flex">
      <LeftNav />
      <div className="dashboard-content flex-grow-1 p-4 bg-light">
        <div className="mb-4">
          <h2 className="fs-five-title fw-bold ms-2">Billing</h2>
          <p className="text-muted ms-2">Manage your payment methods and billing details in one place.</p>
        </div>
        <BillingSubscription />
        <BillingDetails />
        <InvoiceHistory/>
      </div>
    </div>
  );
};

export default Billing;